import React, { useEffect, useState } from 'react';

import amplitude from 'amplitude-js';
import { sendGtEvent } from 'apps/promo/analytics/analytics';
import { DangerouslyHtml } from 'apps/promo/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/promo/components/common/Layout/InfoPage/InfoPage';
import { REACHING_LIMIT_SCREEN, UPGRADE_LIMIT_SCREEN, WAITING_SCREEN } from 'apps/promo/components/sharedComponents/status/Constants';
import PromoReachingLimit from 'apps/promo/components/sharedComponents/status/PromoReachingLimit';
import PromoUpgradeLimit from 'apps/promo/components/sharedComponents/status/PromoUpgradeLimit';
import { getRecipientTypeParam, providerCategories } from 'apps/promo/components/utils/AmplitudeUtils';
import { TRANSFER_CONFIRMATION_SHOWN } from 'apps/promo/constants/amplitude/AmplitudeEvents';
import {
    PAYMENT_COUNTRY,
    PAYMENT_CURRENCY,
    PAYMENT_FLOW,
    PAYMENT_METHOD_AMPLITUDE,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    RECIPIENT_TYPE,
    TRANSFER_ID,
} from 'apps/promo/constants/amplitude/AmplitudeParamName';
import {
    CATEGORY_TRANSFER_TO_CASH,
    CATEGORY_TRANSFER_TO_HOME_DELIVERY,
    CATEGORY_TRANSFER_TO_INTERAC,
    CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC,
} from 'apps/promo/constants/Constants';
import { GT_SEND_SUCCESS } from 'apps/promo/constants/GoogleAnalyticsEvents';
import { GT_AMOUNT_SEND_CURRENCY, GT_SEND_CURRENCY, GT_TRX_ID, GT_USER_ID } from 'apps/promo/constants/GoogleAnalyticsParamNames';
import { AUTH_MY_CARDS_URL, AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'apps/promo/constants/UrlConstants';
import { timer } from 'apps/promo/helpers/utils';
import { useAuth, useExtra, usePageMessages } from 'apps/promo/hooks/selectors';

const Waiting = (props) => {
    let timerID = null;
    const { cardPan, cheque, statusBean } = useExtra();
    const { ballId } = useAuth();
    const { headerTitle, statusText, statusDoneTitle, cancelTransaction30Minutes } = usePageMessages();
    const [screen, setScreen] = useState(WAITING_SCREEN);
    const fromCategory = cheque?.providerFromCategory.toString();
    const toCategory = cheque?.providerToCategory.toString();
    const sendingMethod = providerCategories[fromCategory];
    const deliveryMethod = providerCategories[toCategory];
    const toCountry = cheque?.toCountry?.nameEn;
    const fromCountry = cheque?.fromCountry?.nameEn;

    const isDeliveryOnCashOrInteract = () => {
        return (
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_CASH ||
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY ||
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC ||
            cheque?.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC
        );
    };

    useEffect(() => {
        if (isDeliveryOnCashOrInteract()) {
            timerID = timer(
                timerID,
                () => {
                    window.location.href = AUTH_SEND_MAIN_LINK;
                },
                400,
            );
        } else if (!props.smsOnSuccessPay && props.status) {
            timerID = timer(
                timerID,
                () => {
                    location.reload();
                },
                400,
            );
        }
        return () => clearTimeout(timerID);
    }, []);

    useEffect(() => {
        const paymentParam = sessionStorage?.getItem(cheque?.paymentId);
        amplitude.getInstance().logEvent(TRANSFER_CONFIRMATION_SHOWN, {
            [PAYOUT_COUNTRY]: toCountry,
            [PAYMENT_COUNTRY]: fromCountry,
            [PAYOUT_CURRENCY]: cheque?.amountToCurrency,
            [PAYMENT_CURRENCY]: cheque?.amountFromCurrency,
            [PAYOUT_METHOD]: deliveryMethod,
            [PAYMENT_METHOD_AMPLITUDE]: sendingMethod,
            // [PAYOUT_METHOD_CATEGORY]: '',
            // [PAYMENT_METHOD_CATEGORY]: '',
            [TRANSFER_ID]: cheque?.paymentId,
            [PAYMENT_FLOW]: paymentParam,
            [RECIPIENT_TYPE]: getRecipientTypeParam(statusBean?.recipientType),
        });
        sendGtEvent(GT_SEND_SUCCESS, {
            [GT_USER_ID]: ballId,
            [GT_TRX_ID]: cheque?.paymentId,
            [GT_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [GT_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
        });
    }, []);

    const getPrimaryButtonLink = () => {
        if (props.status?.showUpgradeLimitPromo) {
            return '#';
        } else if (cardPan) {
            return AUTH_MY_CARDS_URL;
        } else if (props.status?.showInviteCodeReferralButton) {
            return AUTH_PROFILE_INVITE + '?showPromoSliders=true';
        } else {
            return AUTH_SEND_MAIN_LINK;
        }
    };
    const primaryButtonOnClick = (e) => {
        if (props.status?.showUpgradeLimitPromo) {
            e.preventDefault();
            setScreen(REACHING_LIMIT_SCREEN);
        }
        sessionStorage?.removeItem(cheque?.paymentId);
    };
    const renderScreen = (currentScreen) => {
        switch (currentScreen) {
            case REACHING_LIMIT_SCREEN:
                return <PromoReachingLimit primaryButtonOnClick={() => setScreen(UPGRADE_LIMIT_SCREEN)} />;
            case UPGRADE_LIMIT_SCREEN:
                return <PromoUpgradeLimit />;
            default:
                return (
                    <InfoPage
                        animatedIconSuccess
                        headerText={headerTitle}
                        secondaryText={statusBean?.canCancelTransaction ? cancelTransaction30Minutes : <DangerouslyHtml dangerouslyHtml={statusText} />}
                        primaryButtonCaption={!isDeliveryOnCashOrInteract() ? statusDoneTitle : null}
                        primaryButtonType="link"
                        primaryButtonLink={getPrimaryButtonLink()}
                        primaryButtonOnClick={primaryButtonOnClick}
                    />
                );
        }
    };
    return renderScreen(screen);
};

export default Waiting;
